import React from 'react'
import ArticleList from './article-list'
import './search.css'
import './showmore-button.css'
import { url } from '../api.config'

class Search extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            keyword: '',
            loaded: 0,
            results: [],
            number: 0,
            mode: 'title',
            showMoreButton: false
        }
    }

    keywordSearch = (e) => {
        this.setState({ keyword: e.target.value })
        fetch(url + '/search?mode=' + this.state.mode + '&keyword=' + e.target.value + '&skip=0&limit=20')
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                if (result.length === 0) {
                    this.setState({ showMoreButton: false })
                }
                this.setState({
                    showMoreButton: true,
                    results: result,
                    loaded: 20
                })
                if (result.length < 20) {
                    this.setState({ showMoreButton: false })
                }
            })
    }

    showMore = () => {
        fetch(url + '/search?mode=' + this.state.mode + '&keyword=' + this.state.keyword + '&skip=' + this.state.loaded + '&limit=20')
            .then((response) => {
                return response.json()
            })
            .then((result) => {
                if (result.length === 0) {
                    this.setState({ showMoreButton: false })
                } else {
                    this.setState({
                        results: this.state.results.concat(result),
                        loaded: this.state.loaded + 20
                    })
                    if (result.length < 20) {
                        this.setState({ showMoreButton: false })
                    }
                }
            });
    }

    modeChange = (e) => {
        this.setState({ mode: e.target.value })
        fetch(url + '/search?mode=' + this.state.mode + '&keyword=' + this.state.keyword + '&skip=0&limit=20')
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                if (result.length === 0) {
                    this.setState({ showMoreButton: false })
                }
                this.setState({
                    showMoreButton: true,
                    results: result,
                    loaded: 20
                })
                if (result.length < 20) {
                    this.setState({ showMoreButton: false })
                }
            })
    }

    render() {
        return (
            <div className='main'>
                <div className='header'>
                    <div className='logo'></div>
                    <div className='page-title'>
                        <h1>Search</h1>
                        <p>検索</p>
                    </div>
                </div>
                <div className='page'>
                    <div className='search-form'>
                        <input type='text' placeholder='Search' onInput={this.keywordSearch} />
                        <select onInput={this.modeChange}>
                            <option value='title'>タイトル検索</option>
                            <option value='text'>全文検索</option>
                        </select>
                    </div>
                    {/* <p>{this.state.number}件見つかりました</p> */}
                    <ArticleList
                        results={this.state.results}
                    />
                    <div className='showmore-button' onClick={this.showMore} style={{ display: this.state.showMoreButton ? '' : 'none' }}>もっと見る</div>
                </div>
            </div>
        )
    }
}

export default Search
